import { useEffect, useState } from "react";
import worshipbackground from "./images/worshipwallpaper.jpg"
import { Cancel, Close } from "@mui/icons-material";
import { Timestamp, doc, setDoc } from "firebase/firestore";
import db, { storage } from "./Backend";
import {ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { CircularProgress } from "@mui/material";

const Createevent = () => {
  const[sImage,setImage]=useState();
  const[imagecopy,setImageCapy]=useState();
  const[imagefocus,setImageFocus]=useState(false);
  const[details,setDetails]=useState("");
  const[showBackgroundImage,setShowbackimage]=useState(false);
  const[showUplaodProgress,setProgress]=useState(false);
  const[success,setSuccessMessage]=useState(false);
  const[eventImageCopy,setEventImageCopy]=useState(false);
  const rowspan = 5
  const now = Timestamp.now();
  const dateCreated = new Date(now?.toDate()).toUTCString();

  useEffect(()=>{
    if(sImage){
      setShowbackimage(true);
    }
  },[sImage])

  const publishEventFlyer=async()=>{
    try{
      if(sImage){
   
        setProgress(true);
        const storageref = ref(storage,'flyers/'+dateCreated);
        const uploadImage = uploadBytesResumable(storageref,sImage);
        uploadImage.on(
          (error)=>{
            console.log(error);
            setProgress(false);
          },
          ()=>{
            getDownloadURL(uploadImage.snapshot.ref).then(async(downloadUrl)=>{
              await setDoc(doc(db,"events","horemowgh"),{
                  eventDetails:details,
                  image:downloadUrl
              });
              localStorage.setItem("eventpic",downloadUrl);
              localStorage.setItem("eventdetails",details);
              setImage(null);
              setSuccessMessage(true);
              setProgress(false);
            })
            .catch((error)=>{
              setProgress(false);
            });
          }
        )
     
      }else{
        await setDoc(doc(db,"events","horemowgh"),{
          eventDetails:details,
      });
      setImage(null);
      setSuccessMessage(true);
      setProgress(false);
      };

    }catch(err){
      console.log(err);
    }

  };

  useEffect(()=>{
    const eventimage = localStorage.getItem("eventpic");
    const eventtext = localStorage.getItem("eventdetails");
    if(eventimage){
      setImageCapy(eventimage);
      setEventImageCopy(true);
    }
    if(eventtext){
      setDetails(eventtext);
    }
  },[]);


    return (
        <div className="createevent">
          <div className="eventdetails">
            <textarea rows={rowspan} placeholder="write your event details here" value={details} onChange={(e)=>setDetails(e.target.value)}/>
          </div>

          <div className="uploadflyer" style={{backgroundImage:`url(${worshipbackground})`}}>
            {eventImageCopy && <img onClick={()=>setImageFocus(true)} src={imagecopy} alt="event flyer"/>}
          
                <input type="file" accept="image/*" id="chooseimage" style={{display:"none"}} onChange={(e)=>setImage(e.target.files[0])}/>
                <label htmlFor="chooseimage">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  height="150px"
                  width="150px"
                  style={{cursor:"pointer"}}
                >
                  <path d="M9 13l3-4 3 4.5V12h4V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-4H5l3-4 1 2z" />
                  <path d="M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z" />
              </svg>
                </label>
          </div>
             
          {sImage && 
          <div>
            <div className={`eventimage ${showBackgroundImage?'show':'hidden'}`}>
              <div className="arrangeimagetext">
                  <img src={URL.createObjectURL(sImage)} alt="event flyer"/>
                  <pre style={{
                    fontWeight:"bolder",
                    width:"60%",
                    whiteSpace:"pre-wrap",
                    color:"black",
                    backgroundColor:"white",
                    padding:"10px"
                  }}
                    >
                    {details}
                  </pre>
              </div>
            
              <button onClick={publishEventFlyer} id="publishbtn"> Publish Event</button>

              <button onClick={()=>setShowbackimage(false)} style={{
              position:"absolute",
              right:"5px",
              top:"10px",
              width:"fit-content",
              cursor:"pointer"
              }}>
              <Close/>
              </button>
              </div>
          </div>
          }

            <p style={{
                backgroundColor:"black",
                color:"white",
                fontWeight:"bold"
                }}>
                  Click on the image symbol to select event flyer for upload.
            </p>
           
            {imagefocus &&
             <div className="imageOnFocus">
              <div className="arrangeimageonfocus">
              <img  src={imagecopy} alt="event flyer"/>
                <button onClick={()=>setImageFocus(false)} style={{
                      position:"absolute",
                      right:"5px",
                      top:"10px",
                      width:"fit-content",
                      cursor:"pointer"
                     }}>
                      <Close/>
              </button>
              </div>
             </div>
             }

             {sImage && 
                <button id="resumepublishing" onClick={()=>setShowbackimage(true)} >Resume publishing</button>
             }
           

            {
              showUplaodProgress && 
              <div style={{
                position:"absolute",
                left:"10%",
                top:"50%",
                backgroundColor:"white"
              }}>
                <CircularProgress/>
              </div>
            }
            {
            success &&
            <div className="toast">
                <h2 style={{color:"white",fontWeight:"bold"}}>Your upcoming event has been published</h2> 
                <button onClick={()=>setSuccessMessage(false)}><Cancel/></button>
            </div>
           }
        </div>
      );
}
 
export default Createevent;